import {KeyLabel} from '../key-label.model';
export enum BlockedDomainStatus {
  OPEN = 'OPEN',
  BLOCKED = 'BLOCKED'
}

export const BlockedDomainStatusLabel = {
  OPEN: 'Open',
  BLOCKED: 'Blocked'
};

export const BlockedDomainStatusKL = () =>
  (Object.keys(BlockedDomainStatusLabel).map(key => new KeyLabel<BlockedDomainStatus>(<BlockedDomainStatus>key,
    BlockedDomainStatusLabel[key])));
